// extracted by mini-css-extract-plugin
module.exports = {"message":"MessageDialog_message__1nBHa","actions":"MessageDialog_actions__1WIeZ"};